// removed by extract-text-webpack-plugin
module.exports = {"component":"_2IiSQe17uEdiv64HlmHFDq","header":"_1SXON29JVguZKe25PUOBr5","centerWithMargin":"_1j6dBa4y3vRvvbbCxO15jq","list":"_1lScCR6t34QhGmvSwe9NZB","action":"_2owrPZinQiC0S7r9fs4A_4","caret":"j6XLbYCKJ-0pLdsSzLz7G","details":"tzEOepujViFvZYz0GQCDG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Links/Links.css
// module id = 1215
// module chunks = 0